import React from 'react'
import { AlertCircle } from 'lucide-react'
import styles from './AnalyticsCard.module.css'

const AnalyticsCard = ({ title, subtitle, loading, error, children, actions, minHeight }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      <div className={styles.body} style={minHeight ? { minHeight } : undefined}>
        {loading && (
          <div className={styles.loadingState}>
            <div className={styles.spinner} />
          </div>
        )}
        {!loading && error && (
          <div className={styles.errorState}>
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}
        {!loading && !error && children}
      </div>
    </div>
  )
}

export default AnalyticsCard
